import { jsx as _jsx } from "react/jsx-runtime";
import { ImageStyled, ImageWrapperStyled } from './styled';
import { useNewsShowContext } from '../context/NewsShowContext';
export const CoverPicture = () => {
    const { data: { news }, } = useNewsShowContext();
    const coverPicture = news.coverPicture.previewUrl;
    return (_jsx(ImageWrapperStyled, { "data-testid": "news-cover-picture", children: _jsx(ImageStyled, { alt: "", fetchPriority: "high", src: coverPicture }) }));
};
//# sourceMappingURL=CoverPicture.js.map